<template>
  <div
    id="layout"
    style="visibility: visible;"
  >
    <div id="north">
      <header-info cur="2"></header-info>
    </div>
    <div
      id="center"
      style="min-height: 677px;"
    >
      <div
        id="content"
        class="content"
        style=""
      >

        <div
          class="center_content container"
          style="visibility: visible;"
        >
          <div class="box-wrap mbox clearfix">
            <div class="lBox">
              <div class="title">
                <p class="title_text">{{ formInfo.title }}</p>
                <div
                  class="title-btns"
                  v-show="isShow"
                ><a
                    class="edit"
                    @click="openBrief"
                  ><i class="icon iconfont">&#xe660;</i>编辑</a></div>
              </div>
              <div class="detail-base clearfix">
                <div class="infor">
                  <p>
                    <span><i>学院：</i>{{ formInfo.academy ? formInfo.academy.title : '--' }}</span>
                    <span><i>对应专业大类：</i>{{
                        formInfo.subject ? formInfo.subject.subject_category.title : '--'
                      }}</span>
                    <span><i>对应专业：</i>{{ formInfo.subject ? formInfo.subject.title : '--' }}</span>
                    <span><i>层次：</i>{{ formInfo.tech_level ? formatLevel(formInfo.tech_level) : '--' }}</span>
                  </p>
                  <p>
                    <span><i>负责人教师：</i>{{ formInfo.master_name ? formInfo.master_name : '--' }}</span>
                    <span><i>申报级别：</i>{{ formInfo.exp_level ? formatExpLevel(formInfo.exp_level) : '--' }}</span>
                    <span><i>实验类型：</i>{{ formInfo.exp_type ? $store.state.dict_exp_type[formInfo.exp_type] : '--' }}</span>
                  </p>
                  <p>
                    <span><i>实验语言：</i>{{ formInfo.exp_language ? $store.state.dict_exp_language[formInfo.exp_language] : '--' }}</span>
                    <span><i>实验已开设期次：</i>{{ formInfo.open_times ? formInfo.open_times : '--' }}</span>
                  </p>
                  <p>
                    <span><i>虚拟仿真必要性：</i><span
                        v-if="formInfo.necessity.Obj1"
                        style="margin-right:10px;margin-bottom: 0;"
                      >高危或极端环境 </span>
                      <span
                        v-if="formInfo.necessity.Obj2"
                        style="margin-right:10px;margin-bottom: 0;"
                      >高成本、高消耗 </span>
                      <span
                        v-if="formInfo.necessity.Obj3"
                        style="margin-right:10px;margin-bottom: 0;"
                      >不可逆操作</span>
                      <span
                        style="margin-bottom: 0;"
                        v-if="formInfo.necessity.Obj4"
                      >大型综合训练</span>
                      <span v-if="formInfo.necessity.Obj1 =='' && formInfo.necessity.Obj2=='' && formInfo.necessity.Obj3=='' && formInfo.necessity.Obj4==''">-</span></span>
                  </p>
                  <p>
                    <span style="display: flex;margin-bottom: 0px;"><i>有效链接：</i><span class="url_link">{{ formInfo.url ? formInfo.url : '--' }}</span></span>
                  </p>
                  <p>
                    <span><i>实验简介：</i>{{ formInfo.brief ? formInfo.brief : '' }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="rBox">
              <div class="title">
                <div class="title-btns">
                  <a
                    class="preview"
                    href="javascript:;"
                    @click="cancel"
                  >返回</a>
                  <router-link
                    :to="'/www/experiment?id=' + formInfo.id"
                    class="preview"
                  >预览</router-link>
                  <a
                    class="submit"
                    href="javascript:;"
                    @click="SubmitReview(2)"
                    v-if="audit_open == 1 && (formInfo.status==1 || formInfo.status==3 || formInfo.status==5)"
                  >提交到院系审核</a>
                </div>
              </div>
              <div class="imgCover">
                <img
                  :src="formInfo.logo "
                  width="130"
                  height="76"
                  :onerror="$store.state.defaultImg"
                >
              </div>
              <div
                v-show="isShow"
                class="upload"
                @click="openProPic"
              >点击上传图片</div>
            </div>
          </div>
          <div class="box-wrap video-box clearfix">
            <div class="lBox">
              <div class="title">
                <p class="title_text">实验简介视频</p>
                <div class="title-btns">
                  <a
                    v-show="isShow"
                    class="upload"
                    href="javascript:;"
                    @click="openVideo"
                  >上传视频</a>
                </div>
              </div>
              <div class="video-wrap">
                <video
                  v-if="formInfo.brief_video"
                  :src="formatVideoPath(formInfo.brief_video, formInfo.brief_resource)"
                  controls=""
                ></video>
                <p
                  v-if="!formInfo.brief_video"
                  class="noUpload"
                >未上传</p>
              </div>
            </div>
            <div class="rBox">
              <div class="title">
                <p class="title_text">实验引导视频</p>
                <div class="title-btns">
                  <a
                    v-show="isShow"
                    class="upload"
                    href="javascript:;"
                    @click="openGuide"
                  >上传视频</a>
                </div>
              </div>
              <div class="video-wrap">
                <video
                  v-if="formInfo.tech_video"
                  :src="formatVideoPath(formInfo.tech_video, formInfo.tech_resource)"
                  controls=""
                ></video>
                <p
                  v-if="!formInfo.tech_video"
                  class="noUpload"
                >未上传</p>
              </div>
            </div>
          </div>
          <div class="box-wrap info-box">
            <div class="menu-box">
              <ul class="menu-list clearfix">
                <li
                  :class="menuSelected == '/admin/experiment_maintain/team' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/team?id=' + params.id">实验团队</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/des' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/des?id=' + params.id">实验描述</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/support' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/support?id=' + params.id">支持与服务</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/net' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/net?id=' + params.id">网络要求</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/frame' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/frame?id=' + params.id">技术架构</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/service_plan' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/service_plan?id=' + params.id">服务计划</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/feature' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/feature?id=' + params.id">实验特色</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/intel' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/intel?id=' + params.id">知识产权</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/promise' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/promise?id=' + params.id">诚信承诺</router-link>
                </li>
                <li
                  :class="menuSelected == '/admin/experiment_maintain/material' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/admin/experiment_maintain/material?id=' + params.id">附件材料</router-link>
                </li>
              </ul>
            </div>
            <div class="part">
              <router-view
                :is-show="isShow"
                :exp-id="params.id"
              ></router-view>
            </div>
          </div>
        </div>

        <div
          id="dialog_overlay"
          class=""
          :style="formatShowWindow(showWindow.proPicOption.proPicDialog)"
        >
          <div id="dialog_bg"></div>
          <div
            id="dialog_panel"
            style="margin-left: -137px; margin-top: -84px;"
            class=""
          >
            <div id="dialog_panel_bg"></div>
            <div id="dialog_title">选择图片</div>
            <div id="dialog_content">
              <div
                class="imgType"
                style="margin-bottom:10px;"
                id="imgType"
              >允许上传的图片格式：jpg</div>
              <div
                id="thumbPreview"
                v-show="showWindow.proPicOption.proPicImgPreview"
              ><img ref="previewImg"></div>
              <div>
                <input
                  id="imageFile"
                  type="file"
                  accept=".jpg"
                  ref="imageFile"
                  @change="imageFileChange"
                >
              </div>
            </div>
            <div id="dialog_control">
              <a
                href="javascript:void(0)"
                @click="hideImageWindow"
                id="dialog_close"
                class="button"
                style="display: inline-block;"
              >取消</a>
              <a
                href="javascript:void(0)"
                @click="confirmImage"
                id="dialog_ok"
                class="button"
                style="display: inline-block;"
              >确认</a>
            </div>
          </div>
        </div>

        <div
          class="form_overlay"
          id="brief_overlay"
          :style="formatShowWindow(showWindow.brief)"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div class="form_title">编辑项目简介</div>
            <a
              href="javascript:void(0)"
              class="overlay-close"
              @click="showWindow.brief = false"
            ><i class="iconfont"></i></a>
            <div class="form_content form_contentEdit">
              <form id="briefForm">
                <div class="item">
                  <span class="label"><i class="require">*</i>层次</span>
                  <select
                    v-model="formBrief.tech_level"
                    type="text"
                    class="form-control"
                  >
                    <option value="0">请选择</option>
                    <option
                      :value="index"
                      v-for="(item,index) in $store.state.dict_school_level"
                      :key="index"
                    >{{item}}</option>
                  </select>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>实验名称</span>
                  <input
                    type="text"
                    :value="formInfo.title"
                    class="form-control"
                    disabled="disabled"
                    maxlength="25"
                  >
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>实验英文名称</span>
                  <input
                    type="text"
                    v-model="formBrief.en_title"
                    class="form-control"
                    maxlength="25"
                  >
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>申报年份</span>
                  <input
                    type="text"
                    :value="formInfo.apply_year"
                    class="form-control"
                    disabled="disabled"
                    maxlength="25"
                  >
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>是否曾被推荐</span>
                  <label>
                    <input
                      v-model="formBrief.recommended"
                      type="radio"
                      value="1"
                      checked="checked"
                    >是</label>
                  <label style="margin-left:10px">
                    <input
                      v-model="formBrief.recommended"
                      type="radio"
                      value="0"
                      checked="checked"
                    >否</label>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>申报级别</span>
                  <label class="check-label">
                    <input
                      class="elevel"
                      type="radio"
                      checked="checked"
                      disabled="disabled"
                    >{{formatExpLevel(formInfo.exp_level)}}</label>
                </div>
                <div class="item">
                  <span class="label"><i class="require"></i>中英双语类课程</span>
                  <div style="float:left">
                    <div
                      class="wrap"
                      style="float:left"
                    ><label><input
                          style="margin-right:10px"
                          type="checkbox"
                          value="1"
                          v-model="formBrief.double_lang"
                        /></label></div>
                  </div>
                </div>
                <div
                  class="item"
                  v-if="formInfo.subject"
                >
                  <span class="label"><i class="require">*</i>所属专业类</span>
                  <select
                    v-model="formBrief.subject_category_id"
                    @change="getSubject()"
                  >
                    <option value="0">请选择所属专业类</option>
                    <option
                      :value="item.id"
                      v-for="item in categoryData"
                      :key="item.id"
                    >{{item.title}}</option>
                  </select>
                </div>
                <div
                  class="item"
                  v-if="formInfo.subject"
                >
                  <span class="label"><i class="require">*</i>专业类代码</span>
                  <input
                    :value="categoryCode"
                    type="text"
                    class="form-control"
                    disabled="disabled"
                    maxlength="25"
                  >
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>对应专业</span>
                  <select v-model="formBrief.subject_id">
                    <option value="0">请选择对应专业</option>
                    <option
                      :value="item.id"
                      v-for="item in subjectData"
                      :key="item.id"
                    >{{item.title}}</option>
                  </select>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>专业代码</span>
                  <input
                    :value="subjectCode"
                    type="text"
                    class="form-control"
                    disabled="disabled"
                    maxlength="25"
                  >
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>实验类型</span>
                  <div style="float: left;">
                    <div
                      v-for="(item,index) in $store.state.dict_exp_type"
                      :key="index"
                    >
                      <label>
                        <input
                          v-model="formBrief.exp_type"
                          type="radio"
                          :value="index"
                          checked="checked"
                        >{{item}}</label>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>虚拟仿真必要性</span>
                  <div style="float:left">
                    <div
                      class="wrap"
                      style="float:left"
                    ><label><input
                          style="margin-right:10px"
                          type="checkbox"
                          v-model="formBrief.necessity.Obj1"
                        />高危或极端环境</label></div>
                    <div
                      class="wrap"
                      style="float:left;margin-left:20px"
                    ><label><input
                          style="margin-right:10px"
                          type="checkbox"
                          v-model="formBrief.necessity.Obj2"
                        />高成本、高消耗</label></div><br>
                    <div
                      class="wrap"
                      style="float:left"
                    ><label><input
                          style="margin-right:10px"
                          type="checkbox"
                          v-model="formBrief.necessity.Obj3"
                        />不可逆操作</label></div>
                    <div
                      class="wrap"
                      style="float:left;margin-left:20px"
                    ><label><input
                          style="margin-right:10px"
                          type="checkbox"
                          v-model="formBrief.necessity.Obj4"
                        />大型综合训练</label></div>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>实验语言</span>
                  <div style="float: left;">
                    <div
                      v-for="(item,index) in $store.state.dict_exp_language"
                      :key="index"
                    >
                      <label>
                        <input
                          v-model="formBrief.exp_language"
                          type="radio"
                          :value="index"
                          checked="checked"
                        >{{item}}</label>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>负责人</span>
                  <input
                    type="text"
                    :value="formInfo.master_name ? formInfo.master_name : '--'"
                    class="form-control"
                    disabled="disabled"
                  >
                </div>
                <div class="item">
                  <span class="label">实验已开设期次</span>
                  <select
                    v-model="formBrief.open_times"
                    type="text"
                    class="form-control"
                  >
                    <option value="0">请选择</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                  </select>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>有效链接</span>
                  <div>
                    <input
                      v-model="formBrief.url"
                      type="text"
                      class="form-control"
                      maxlength="500"
                    >
                  </div>
                </div>
                <div class="item">
                  <span class="label">备用链接</span>
                  <div>
                    <input
                      v-model="formBrief.url_bak"
                      type="text"
                      class="form-control"
                      maxlength="500"
                    >
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>中文介绍</span>
                  <textarea
                    v-model="formBrief.brief"
                    rows="8"
                    class="form-control"
                    placeholder="必填"
                  ></textarea>
                  <div
                    class="word-count"
                    id="textMaxNumber1"
                  ></div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>英文介绍</span>
                  <textarea
                    v-model="formBrief.en_brief"
                    rows="8"
                    class="form-control"
                    placeholder="必填"
                  ></textarea>
                  <div class="word-count"></div>
                </div>
                <div class="item">
                  <span class="label">要求</span>
                  <div class="txtbox">
                    <div class="accord">
                      <p>
                        项目简介是指根据项目本身的建设情况提炼和升华的宣传用语，旨在推广本项目。要求语言生动、形象、具有吸引力。项目简介采用文本呈现，需符合文本素材相关要求。中文简介控制在200字以内，英文简介控制在1000字符以内。</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="form_control">
              <a
                href="javascript:;"
                @click="showWindow.brief = false"
                class="button close"
                id="brief_close"
              >取消</a>
              <a
                href="javascript:;"
                @click="saveBrief"
                class="button"
                id="brief_submit"
              >提交</a>
            </div>
          </div>
        </div>

        <div
          class="form_overlay"
          id="proPic_overlay"
          :style="formatShowWindow(showWindow.proPic)"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div class="form_title">编辑项目图片</div>
            <a
              href="javascript:void(0)"
              class="overlay-close"
              @click="showWindow.proPic=false"
            ><i class="iconfont"></i></a>
            <div class="form_content">
              <form id="proPicForm">
                <div class="item">
                  <span class="label"><i class="require">*</i>项目图片</span>
                  <div class="item-box">
                    <input
                      type="text"
                      disabled="disabled"
                    >
                    <span
                      class="button"
                      id="uploadImg"
                      @click="showImageWindow"
                    >添加图片</span>
                    <ul
                      id="viewProPicDemo"
                      class="uploadImgPreview"
                    >
                      <li>
                        <img
                          src="../../../assets/images/picDemo.jpg"
                          data-original="../../assets/images/picDemo.jpg"
                          data-photo="../../assets/images/picDemo.jpg"
                          alt="项目示例图片"
                          onerror=""
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="clearfix"></div>
                  <div
                    class="item"
                    v-show="formLogo.logo.length > 0"
                  >
                    <span class="label">&nbsp;</span>
                    <div id="preview">
                      <img
                        :src="formLogo.logo"
                        height="50"
                        style="margin: 10px 0 0 10px;"
                      >
                    </div>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>项目图片要求</span>
                  <div class="txtbox">
                    <div class="accord">
                      <p>项目图是指代表本项目所学知识或实践内容的特色图片，这是是项目个性化的体现，是表达项目理念和风格的载体。</p>
                      <p>图片要求：</p>
                      <p>1.默认图片高度为162px，设计封面过程中需内容偏上；</p>
                      <p>2.适用区域：实验空间首页项目图、详情页项目图</p>
                      <p>3.图片参数：尺寸为388px*224px，100K以内JPG格式；</p>
                      <p>设计要求：</p>
                      <p>1.图片上不能有任何方案；</p>
                      <p>2.画面简洁清晰，突出项目主题，有一定的统一性与丰富性，切勿简单堆砌；</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="form_control">
              <a
                @click="showWindow.proPic = false"
                href="javascript:;"
                class="button close"
                id="proPic_close"
              >取消</a>
              <a
                @click="saveLogo"
                href="javascript:;"
                class="button"
                id="proPic_submit"
              >提交</a>
            </div>
          </div>
        </div>

        <div
          class="form_overlay"
          id="video_overlay"
          :style="formatShowWindow(showWindow.video)"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div class="form_title">编辑实验简介视频</div>
            <div class="form_content">
              <form id="videoForm">
                <div class="item">
                  <span class="label"><i class="require">*</i>实验简介视频</span>
                  <div class="item-box clearfix">
                    <input
                      type="text"
                      id="videoPath"
                      disabled="disabled"
                      v-model="formVideo.brief_video"
                    >
                    <span
                      class="button"
                      id="uploadVideo"
                      @click="showFileWindow"
                    >上传</span>
                    <br>
                    <span
                      style="font-size:12px;line-height: 1.6em;margin-top: 8px;"
                      class="text-danger"
                    >实验简介视频内容应包括实验教学项目的基本情况、项目特色、技术手段和应用情况等。</span>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>视频及音频要求</span>
                  <div class="txtbox">
                    <div class="accord">
                      <p>视频要求：</p>
                      <p>1.视频时长控制在3分钟以内；</p>
                      <p>2.视频文件大小不超过500M；</p>
                      <p>3.画面清晰、图像稳定，声音与画面同步且无杂音（如有解说应采用标准普通话配音）</p>
                      <p>4.分辨率：1920*1080 25P或以上；</p>
                      <p>5.编码为：H.264，H.264/AVC High Profile Level 4.2或以上；</p>
                      <p>6.封装格式为：MP4；</p>
                      <p>7.码流为：不小于2Mbps。</p>
                      <p>音频和字幕要求：</p>
                      <p>1.音频格式为：混合立体声；</p>
                      <p>2.编码为：AAC、MP3；</p>
                      <p>3.码流为：不低于128kbps，采样率48000Hz；</p>
                      <p>字幕要求：直接压制在介质上。</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="form_control">
              <a
                href="javascript:;"
                @click="showWindow.video = false"
                class="button close"
                id="video_close"
              >取消</a>
              <a
                href="javascript:;"
                @click="saveVideo"
                class="button"
                id="video_submit"
              >提交</a>
            </div>
          </div>
        </div>

        <div
          class="form_overlay"
          id="guide_overlay"
          :style="formatShowWindow(showWindow.guide)"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div class="form_title">编辑教学引导视频</div>
            <div class="form_content">
              <form id="guideForm">
                <div class="item">
                  <span class="label"><i class="require">*</i>教学引导视频</span>
                  <div class="item-box clearfix">
                    <input
                      type="text"
                      id="guideVideo"
                      disabled="disabled"
                      v-model="formGuide.tech_video"
                    >
                    <span
                      class="button"
                      id="uploadGuideVideo"
                      @click="showFileWindow"
                    >上传</span>
                    <br>
                    <span
                      style="font-size:12px;line-height: 1.6em;margin-top: 8px;"
                      class="text-danger"
                    >教学引导视频内容应包括实验教学项目的实验目的、实验要求、操作流程等。</span>
                  </div>
                </div>
                <div class="item">
                  <span class="label"><i class="require">*</i>视频及音频要求</span>
                  <div class="txtbox">
                    <div class="accord">
                      <p>视频要求：</p>
                      <p>1.视频时长控制在5-8分钟以内；</p>
                      <p>2.视频文件大小不超过500M；</p>
                      <p>3.画面清晰、图像稳定，声音与画面同步且无杂音（如有解说应采用标准普通话配音）</p>
                      <p>4.分辨率：1920*1080 25P或以上；</p>
                      <p>5.编码为：H.264，H.264/AVC High Profile Level 4.2或以上；</p>
                      <p>6.封装格式为：MP4；</p>
                      <p>7.码流为：不小于2Mbps。</p>
                      <p>音频和字幕要求：</p>
                      <p>1.音频格式为：混合立体声；</p>
                      <p>2.编码为：AAC、MP3；</p>
                      <p>3.码流为：不低于128kbps，采样率48000Hz；</p>
                      <p>字幕要求：直接压制在介质上。</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="form_control">
              <a
                href="javascript:;"
                @click="showWindow.guide = false"
                class="button close"
                id="guide_close"
              >取消</a>
              <a
                href="javascript:;"
                @click="saveGuide"
                class="button"
                id="guide_submit"
              >提交</a>
            </div>
          </div>
        </div>

        <div
          id="file-upload-overlay"
          :style="showWindow.bigFile ? 'display: block' : ''"
        >
          <div class="file-upload-bg"></div>
          <div class="file-upload">
            <div
              class="file-upload-type"
              v-show="showWindow.courseware"
            >允许上传的文件扩展名：jpg, png, mp4</div>
            <div
              class="file-upload-type"
              v-show="showWindow.video"
            >允许上传的文件扩展名：mp4</div>
            <div
              class="file-upload-type"
              v-show="showWindow.guide"
            >允许上传的文件扩展名：mp4</div>
            <div
              class="file-upload-type"
              v-show="showWindow.teach"
            >允许上传的文件扩展名：mp4,doc,jpg,png,pdf</div>
            <div
              class="file-upload-type"
              v-show="showWindow.promise"
            >允许上传的文件扩展名：jpg, png</div>
            <div
              class="file-upload-type"
              v-show="showWindow.materialsfile"
            >允许上传的文件扩展名：mp4,doc,jpg,png,pdf</div>
            <div
              class="file-upload-close"
              @click="hideFileWindow"
            >×</div>
            <span
              class="file_uploadBtn"
              id="file_uploadBtn"
              style="display: block;"
            >
              选择文件<input
                type="file"
                id="file_fileInput"
                ref="docFile"
                style="display: block;"
                accept=".mp4"
                @change="fileChange"
              >
            </span>
            <div
              class="fileBox"
              id="file_uploadBox"
              style="display: block;"
            >
              <span
                class="pauseBtn"
                id="file_pauseBtn"
                style="display: none;"
              >暂停</span>
              <span
                class="goBtn"
                id="file_goBtn"
                style="display:none;"
              >继续</span>
              <div
                class="filename"
                id="file_filename"
                style="display: none;"
              ></div>
              <div
                class="pbar"
                :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
              >
                <div
                  class="progress"
                  id="file_progress"
                  :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
                ></div>
                <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>

      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>

      <div id="footer"></div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'

export default {
  name: 'ExperimentMaintainPart',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      audit_open: 0,
      isShow: false,
      menuSelected: '',
      params: {
        id: 0
      },
      tabIndex: 0,
      showWindow: {
        brief: false,
        proPic: false,
        proPicOption: {
          proPicDialog: false,
          proPicImgPreview: false,
          uploaded_img: '',
          uploaded_name: ''
        },
        video: false,
        guide: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        }
      },
      formInfo: {
        id: 0,
        academy_id: 0,
        academy: null,
        subject_id: 0,
        subject: null,
        master_id: 0,
        master_name: null,
        title: '',
        en_title: '',
        created: '',
        recommended: 1,

        necessity: {
          Obj1: false,
          Obj2: false,
          Obj3: false,
          Obj4: false
        },
        tech_level: 0,
        exp_type: '',
        exp_language: '',
        url: '',
        url_bak: '',
        open_times: 0,
        isTeacherCheck: 0,
        exp_level: 0,
        duration: '',
        concurrence: '',
        brief: '',
        en_brief: '',
        claim: '',
        logo: '',

        brief_video: '',
        tech_video: '',
        brief_resource: null,
        tech_resource: null,

        goal: '',

        theory_content: '',
        theory_point: '',

        device: '',
        materials: '',
        tech_func: '',

        step_claim_des: '',
        step_claim_step: '',
        step_claim_step_des: '',

        result_claim_record: '',
        result_claim_type_ck1: false,
        result_claim_type_ck2: false,
        result_claim_type_ck3: false,
        result_claim_type_ck3_text: '',
        result_claim_content: '',

        check_claim: '',

        student_claim_subject: '',
        student_claim_content: '',

        proj_situation_online_time: '',
        proj_situation_open_time: '',
        proj_situation_student_count: '',
        proj_situation_social: '',

        net_claim_content: '',
        net_claim_count: '',

        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: '',

        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: '',

        user_hardware_claim_computer: '',
        user_hardware_claim_other: '',

        user_special_claim_hardware: '',
        user_special_claim_other: '',

        net_safe_claim: '',

        online_support: '',

        service_plan: '',

        frame_content: '',
        frame_file: '',

        tech_goal_dev: '',
        tech_goal_tool: '',
        tech_goal_level: '',

        platform_lang: '',
        platform_tool: '',
        platform_db: '',

        feature_design: '',
        feature_tech: '',
        feature_appraise: '',
        feature_more: '',

        intellectual_register: '',
        intellectual_name: '',
        intellectual_same: '',
        intellectual_username: '',
        intellectual_power: '',
        intellectual_no: '',

        promise_file: '',

        materials_file: ''
      },
      categoryData: [],
      subjectData: [],
      formBrief: {
        en_title: '',
        recommended: 1,
        exp_type: '',
        necessity: {
          Obj1: false,
          Obj2: false,
          Obj3: false,
          Obj4: false
        },
        tech_level: 0,
        exp_language: '',
        open_times: 0,
        double_lang: false,
        url: '',
        url_bak: '',
        isTeacherCheck: 0,
        duration: '',
        concurrence: '',
        brief: '',
        en_brief: '',
        subject_category_id: '',
        subject_id: ''
      },
      formLogo: {
        logo: ''
      },
      formVideo: {
        brief_video: '',
        brief_resource_id: 0
      },
      formGuide: {
        tech_video: '',
        tech_resource_id: 0
      },
      sensitiveWord: []
    }
  },
  computed: {
    categoryCode () {
      for (let i = 0; i < this.categoryData.length; i++) {
        if (this.categoryData[i].id === this.formBrief.subject_category_id) {
          return this.categoryData[i].code
        }
      }
      return ''
    },
    subjectCode () {
      for (let i = 0; i < this.subjectData.length; i++) {
        if (this.subjectData[i].id === this.formBrief.subject_id) {
          return this.subjectData[i].code
        }
      }
      return ''
    },
    platform_level () {
      return this.$store.state.platform_level
    }
  },
  // 事件处理器
  methods: {
    async checkAuditOpen () {
      await this.$http.get('/allowany/globalsetting/').then(async (data) => {
        if (data.results.length > 0) {
          this.audit_open = data.results[0].audit_open
          this.globalSettingId = data.results[0].id
        } else {
          this.audit_open = 1
          await this.$http.post('/globalsetting/', {
            audit_open: 1
          }).then((data) => {
            console.log(data)
            this.globalSettingId = data.id
          })
        }
      })
    },
    getUrlKey(name) {
      const url = window.location.href
      const dzUrl = url.split('#')[0]
      if (dzUrl.split('?').length <= 1) {
        return ''
      }
      const csArr = dzUrl.split('?')[1].split('&')
      const cs = {}
      for (let i = 0; i < csArr.length; i++) {
        cs[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      return cs[name]
    },
    updateMenuSelected() {
      const url = window.location.href
      const arrUrl = url.split('//')
      const start = arrUrl[1].indexOf('/')
      let relUrl = arrUrl[1].substring(start)

      if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0]
      }
      relUrl = relUrl.replace('#', '')
      this.menuSelected = relUrl
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.params.id + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        if (this.formInfo.status === 1 || this.formInfo.status === 3) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        if (this.$store.state.platform_level === 3 && this.$store.state.userInfo.role === 3) {
          this.isShow = true
        }
        if (this.$store.state.platform_level === 4 && this.$store.state.userInfo.role === 4) {
          this.isShow = true
        }
        if (this.$store.state.userInfo.role === 0) {
          this.isShow = true
        }
        this.formInfo.necessity = data.necessity ? JSON.parse(data.necessity) : {}
      }).catch((error) => {
        console.log(error)
      })
    },
    // 搜索大类
    async searchCategory() {
      await this.$http.get('/allowany/subject_category/', {
        params: {
          page: 1,
          size: 1000,
          status: 1
        }
      }).then((data) => {
        this.categoryData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    async getSubject() {
      await this.$http.get('/allowany/subject/', {
        params: {
          page: 1,
          size: 1000,
          status: 1,
          subject_category_id: this.formBrief.subject_category_id
        }
      }).then((data) => {
        this.subjectData = data.results
        this.formBrief.subject_id = 0
      }).catch((error) => {
        console.log(error)
      })
    },
    async openBrief() {
      this.showWindow.brief = true
      this.formBrief.en_title = this.formInfo.en_title
      this.formBrief.recommended = this.formInfo.recommended
      this.formBrief.exp_type = this.formInfo.exp_type
      this.formBrief.necessity = JSON.parse(JSON.stringify(this.formInfo.necessity))
      this.formBrief.exp_language = this.formInfo.exp_language
      this.formBrief.tech_level = this.formInfo.tech_level
      this.formBrief.url = this.formInfo.url
      this.formBrief.url_bak = this.formInfo.url_bak
      this.formBrief.open_times = this.formInfo.open_times
      this.formBrief.isTeacherCheck = this.formInfo.isTeacherCheck
      this.formBrief.duration = this.formInfo.duration
      this.formBrief.concurrence = this.formInfo.concurrence
      this.formBrief.brief = this.formInfo.brief
      this.formBrief.en_brief = this.formInfo.en_brief
      this.formBrief.double_lang = this.formInfo.double_lang
      this.formBrief.subject_category_id = this.formInfo.subject ? this.formInfo.subject.subject_category_id : ''
      await this.getSubject()
      this.formBrief.subject_id = this.formInfo.subject_id
    },
    openProPic() {
      this.showWindow.proPic = true
      this.showWindow.proPicOption.uploaded_img = ''
      this.formLogo.logo = this.formInfo.logo
    },
    openVideo() {
      this.formVideo.brief_video = this.formInfo.brief_video
      this.showWindow.video = true
    },
    openGuide() {
      this.formGuide.tech_video = this.formInfo.tech_video
      this.showWindow.guide = true
    },
    formatLevel(value) {
      return value ? this.$store.state.dict_school_level[value] : '--'
    },
    formatExpLevel(value) {
      return value ? this.$store.state.dict_exp_level[value] : '--'
    },
    cancel() {
      if (this.$store.state.userInfo.role === 11) {
        this.$router.push('/admin/experimentTeacher')
      } else {
        this.$router.push('/admin/experiment')
      }
    },
    async SubmitReview(status) {
      const url = '/experiment/' + this.params.id + '/'
      await this.$http.put(url, {
        status: status
      }).then(() => {
        this.$layer.msg('提交成功！')
        this.cancel()
      }).catch((error) => {
        console.log(error)
      })
    },
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async saveBrief() {
      if (this.formBrief.tech_level === 0) {
        this.$layer.msg('请选择层次')
        return
      }
      if (!this.formBrief.en_title) {
        this.$layer.msg('请填写实验英文名称')
        return
      }
      if (!this.formBrief.exp_type) {
        this.$layer.msg('请选择实验类型')
        return
      }
      if (!this.formBrief.exp_language) {
        this.$layer.msg('请选择实验语言')
        return
      }
      if (this.formBrief.open_times === 0) {
        this.$layer.msg('请选择实验开设期次')
        return
      }
      if (!this.formBrief.url) {
        this.$layer.msg('请填写有效链接')
        return
      }
      if (!this.formBrief.brief) {
        this.$layer.msg('请填写中文介绍！')
        return
      }
      if (this.formBrief.brief.length > 200) {
        this.$layer.msg('中文介绍不能超过200字！')
        return
      }
      const check1 = this.utils.getWords(this.formBrief.brief, this.sensitiveWord)
      if (check1) {
        this.$layer.msg('中文介绍有敏感词!')
        return false
      }
      if (!this.formBrief.en_brief) {
        this.$layer.msg('请填写英文介绍！')
        return
      }
      if (this.formBrief.en_brief.length > 1000) {
        this.$layer.msg('英文介绍不能超过1000字！')
        return
      }
      const check2 = this.utils.getWords(this.formBrief.en_brief, this.sensitiveWord)
      if (check2) {
        this.$layer.msg('英文介绍有敏感词!')
        return false
      }
      if (this.formBrief.subject_category_id === 0) {
        this.$layer.msg('请选择所属专业类')
        return
      }
      if (this.formBrief.subject_id === 0) {
        this.$layer.msg('请选择对应专业')
        return
      }
      // this.formBrief.necessity = JSON.stringify(this.formBrief.necessity)
      // this.formBrief.double_lang = this.formBrief.double_lang ? 1 : 0
      const params = {
        en_title: this.formBrief.en_title,
        recommended: this.formBrief.recommended,
        exp_type: this.formBrief.exp_type,
        necessity: JSON.stringify(this.formBrief.necessity),
        tech_level: this.formBrief.tech_level,
        exp_language: this.formBrief.exp_language,
        open_times: this.formBrief.open_times,
        double_lang: this.formBrief.double_lang ? 1 : 0,
        url: this.formBrief.url,
        url_bak: this.formBrief.url_bak,
        isTeacherCheck: this.formBrief.isTeacherCheck,
        duration: this.formBrief.duration,
        concurrence: this.formBrief.concurrence,
        brief: this.formBrief.brief,
        en_brief: this.formBrief.en_brief,
        subject_category_id: this.formBrief.subject_category_id,
        subject_id: this.formBrief.subject_id

      }
      const url = '/experiment/' + this.params.id + '/'
      await this.$http.put(url, params).then((data) => {
        if (data.id) {
          this.getInfo(this.$route.query.id)
          this.$layer.msg('提交成功！')
          // this.formInfo.en_title = this.formBrief.en_title
          // this.formInfo.recommended = this.formBrief.recommended
          // this.formInfo.exp_type = this.formBrief.exp_type
          // this.formInfo.necessity = JSON.parse(this.formBrief.necessity)
          // this.formInfo.url = this.formBrief.url
          // this.formInfo.isTeacherCheck = this.formBrief.isTeacherCheck
          // this.formInfo.duration = this.formBrief.duration
          // this.formInfo.concurrence = this.formBrief.concurrence
          // this.formInfo.brief = this.formBrief.brief
          this.showWindow.brief = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showImageWindow() {
      this.showWindow.proPicOption.proPicImgPreview = false
      this.showWindow.proPicOption.proPicDialog = true
    },
    hideImageWindow() {
      this.showWindow.proPicOption.proPicDialog = false
    },
    async saveLogo() {
      const url = '/experiment/' + this.params.id + '/'
      await this.$http.put(url, this.formLogo).then((data) => {
        if (data.id) {
          this.formInfo.logo = this.formLogo.logo
          this.showWindow.proPic = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showFileWindow() {
      if (this.isShow) {
        this.showWindow.bigFile = true
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          // console.dir(e)
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()

        // 此处处理data
        if (this.showWindow.video) {
          this.formVideo.brief_video = data
        }
        if (this.showWindow.guide) {
          this.formGuide.tech_video = data
        }
        if (this.showWindow.courseware) {
          this.formCourseWare.src = data
          this.formCourseWare.size = this.$refs.docFile.files[0].size
        }
        if (this.showWindow.teach) {
          if (this.teachType === 1) {
            this.formTeach.teachChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else {
            this.formTeach.expChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          }
        }
        if (this.showWindow.promise) {
          var myDate = new Date()
          this.formPromise = {
            path: data,
            year: myDate.getFullYear(),
            month: myDate.getMonth() + 1,
            day: myDate.getDate()
          }
          this.formInfo.promise_file = this.formPromise
          this.savePromise(1)
          this.showWindow.promise = false
        }
        if (this.showWindow.materialsfile) {
          if (this.MaterialsFileType === 1) {
            this.formMaterialsFile.politicalArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else if (this.MaterialsFileType === 2) {
            this.formMaterialsFile.learnArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else if (this.MaterialsFileType === 3) {
            this.formMaterialsFile.outsideArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          }
        }
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    async toFileMaker (item) {
      await this.$http.get('/file_maker/', {
        params: {
          id: item.id
        }
      }).then((data) => {
        console.log(data)
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    },
    formatVideoPath(briefVideo, briefResource) {
      if (briefResource && briefResource.status === 3) {
        return '/static/mp4/sd/' + briefResource.newSourceDIR + '/' + briefResource.newSourceID + '.mp4'
      } else {
        return briefVideo
      }
    },
    async saveVideo() {
      await this.$http.post('/resource/', {
        path: this.formVideo.brief_video,
        status: 0
      }).then(async (resourceData) => {
        this.formVideo.brief_resource_id = resourceData.id

        const url = '/experiment/' + this.params.id + '/'
        await this.$http.put(url, this.formVideo).then((data) => {
          if (data.id) {
            this.formInfo.brief_video = this.formVideo.brief_video
            this.formInfo.brief_resource = resourceData
            this.showWindow.video = false
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })

        await this.$http.get('/file_maker/', {
          params: {
            id: resourceData.id
          }
        }).then(async (makeData) => {
          console.log(makeData)
        }).catch(() => {
          console.log('加工机加工失败！')
        })
      }).catch(() => {
        this.$layer.msg('修改失败！')
      })
    },
    async saveGuide() {
      await this.$http.post('/resource/', {
        path: this.formGuide.tech_video,
        status: 0
      }).then(async (resourceData) => {
        this.formGuide.tech_resource_id = resourceData.id

        const url = '/experiment/' + this.params.id + '/'
        await this.$http.put(url, this.formGuide).then((data) => {
          if (data.id) {
            this.formInfo.tech_video = this.formGuide.tech_video
            this.formInfo.tech_resource = resourceData
            this.showWindow.guide = false
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })

        await this.$http.get('/file_maker/', {
          params: {
            id: resourceData.id
          }
        }).then(async (makeData) => {
          console.log(makeData)
        }).catch(() => {
          console.log('加工机加工失败！')
        })
      }).catch(() => {
        this.$layer.msg('修改失败！')
      })
    },
    async imageFileChange() {
      const uploadUrl = '/files/' + this.$refs.imageFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.imageFile.files[0]).then((data) => {
        // console.log(data)
        this.showWindow.proPicOption.uploaded_img = data
        this.showWindow.proPicOption.uploaded_name = this.$refs.imageFile.files[0].name
        this.showWindow.proPicOption.proPicImgPreview = true
        this.$refs.previewImg.src = data
      }).catch(() => {
        this.$layer.msg('上传失败！')
      })
    },
    confirmImage() {
      if (this.showWindow.proPic) {
        this.formLogo.logo = this.showWindow.proPicOption.uploaded_img
      }
      if (this.showWindow.frame) {
        this.frameFileList.push({
          src: this.showWindow.proPicOption.uploaded_img,
          name: this.showWindow.proPicOption.uploaded_name
        })
      }
      this.hideImageWindow()
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.updateMenuSelected()
    this.getInfo()
    this.searchCategory()
    this.getSensitiveWord()
    window.scroll(0, 0)
  },
  async created() {
    this.params.id = this.getUrlKey('id')
    await this.checkAuditOpen()
  }
}
</script>

<style scoped src="../../../assets/css/project-detail.css"></style>
<style scoped src="../../../assets/css/table.css"></style>
<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .disabled {
      padding: 7px 20px;
      background: #eee;
      color: #666;
      border: 1px solid #666;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
</style>
